import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper } from '@mui/material';

import { Loader } from 'ui';

import { fetchShopProductsAction, fetchShopProductPropertiesAction } from '../../store/shopActions';
import { getProductById } from '../../selectors/shopSelectors';
import { ShopPanelProductCreator } from '../../components/ShopPanelProductCreator';
import { ShopPanelPackageCreator } from '../../components/ShopPanelPackageCreator';

const ShopPanelEdit = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { productId } = useParams();

  const product = useSelector(getProductById(Number(productId)));

  useEffect(() => {
    dispatch(fetchShopProductPropertiesAction());
    dispatch(fetchShopProductsAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t('Subscriptions panel')}</Typography>
      </Box>
      {!product ? (
        <Loader center />
      ) : (
        <Paper elevation={3}>
          <Box p={2}>
            {product.isPackage ? (
              <ShopPanelPackageCreator product={product} />
            ) : (
              <ShopPanelProductCreator product={product} />
            )}
          </Box>
        </Paper>
      )}
    </>
  );
};

export { ShopPanelEdit };
